<template>
    <el-button
            style="float: left"
            type="primary"
            :disabled="!isVerify"
            :loading="finishCraftLoading"
            @click="finishCraft"
            icon="el-icon-finished"
            size="mini">
        上报
    </el-button>
</template>

<script>
    import {mapState, mapMutations} from 'vuex'

    export default {
        name: "FinishCurrentCraftButton",
        data() {
            return {finishCraftLoading: false}
        },
        props: {
            isVerify: {type: Boolean, required: true},
            checkFinish: {
                type: Function,
                default: function () {
                    return () => {
                        return true
                    }
                }
            },
        },
        computed: {...mapState(['currentCraft'])},
        methods: {
            // 完成上报
            finishCraft() {
                if (this.checkFinish()) {
                    this.finishCraftLoading = true
                    const finishUrl = `${this.$const.craftListUrl}${this.currentCraft.id}/finish/`
                    this.$postRequest(finishUrl)
                        .then((response) => {
                            const craft_record = response.data
                            this.updateCurrentCraft(craft_record) // 更新 currentCraft
                            this.finishCraftLoading = false
                            this.$message.success('上报工艺记录单完成！')
                            this.removeCraft(craft_record)
                        })
                        .catch((error) => {
                            this.finishCraftLoading = false
                        })
                }

            },
            ...mapMutations(['updateCurrentCraft'])
        },
    }
</script>

<style scoped>

</style>